import { colorTheme, textTheme } from "@milestone/component-library";
import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
`;

export const YearsContainer = styled.div`
  ${textTheme.subtitle1};
  display: flex;
  flex-direction: row;
  gap: 165px;
  margin-top: 40px;
  margin-left: 55px;
`;

export const YearWrapper = styled.div``;

export const MonthWrapper = styled.div`
  ${textTheme.subtitle1};
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding-top: 20px;
`;

export const Year = styled.h4`
  ${textTheme.h4};
  margin: 0;
  padding: 0;
`;

export const DotImg = styled.img`
  width: 10px;
  height: 10px;
  align-self: end;
  padding-bottom: 5px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 20px;
  padding-left: 20px;
  border-left: 1px solid #c4c4c4;
  margin-left: 5px;
`;

export const FilledCheckInContainer = styled.div`
  ${textTheme.body1};
  color: ${colorTheme.black};
  background: #ffffff;
  border: 1px solid rgba(195, 203, 205, 0.35);
  box-sizing: border-box;
  width: 150px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 15px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;
export const SVGButton = styled.button.attrs(() => ({
  type: "button",
}))`
  font-size: 100%;
  font-family: inherit;
  border: 0;
  outline: 0;
  padding: 0;
  background: ${colorTheme.white};
  cursor: pointer;
  height: 24px;
  width: 24px;
  > svg {
    width: 24px;
    height: 24px;
    color: ${colorTheme.newBlue};
  }
`;

export const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
  cursor: pointer;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const PreviewContainer = styled.div`
  cursor: auto;
  z-index: 10;
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 28px 54px 46px;
  background-color: ${colorTheme.white};
  width: 600px;
  border-radius: 6px;
`;
